import { clearSession } from '../utils/session';

// No migration of persistent credentials: the new policy starts with a fresh sign-in.
clearSession(localStorage);
localStorage.removeItem('auth-storage');
export const authStorage = sessionStorage;
